import { Component } from '@angular/core';
import { AppRoutesEnum } from '@shared/enums';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '(window:resize)': 'onScreenResize($event)',
    },
})
export class MobileMenuComponent {
    appRoutes = AppRoutesEnum;
    isSidebarVisible = false;
    routerSubscription!: Subscription;

    constructor(private router: Router) {}

    toggleSidebar(): void {
        this.isSidebarVisible = !this.isSidebarVisible;
    }

    onScreenResize(event: any) {
        if (event.target.innerWidth <= 990) {
            this.routerSubscription = this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationStart && this.isSidebarVisible) {
                    this.isSidebarVisible = false;
                }
            });
        }

        if (event.target.innerWidth > 991) {
            this.isSidebarVisible = false;
            this.routerSubscription?.unsubscribe();
        }
    }
}
